// FRU-24835: the reverse mortgage flow in the rates form, decided from the URL.

type Query = { [key: string]: any };

const scalar = (v: any): string => String((Array.isArray(v) ? v[0] : v) || '').toLowerCase();

/** A reverse mortgage request: LoanPurpose=refinance&FormType=reverse, the two parameters the form initializes from. */
export function isReverseQuery(qp: Query): boolean {
  return scalar(qp['FormType']) === 'reverse' && scalar(qp['LoanPurpose']) === 'refinance';
}

/** FAST mode for this URL. Reverse never runs it, so its eligibility questions (age, primary residence) are always real
 *  answers. Every other flow is exactly as before: auto_mode=yes starts it, fast_variant=yes allows it. */
export function fastModeFromQuery(qp: Query): { auto: boolean, allowed: boolean } {
  if (isReverseQuery(qp)) {
    return { auto: false, allowed: false };
  }
  const auto = qp['auto_mode'] === 'yes';
  return { auto, allowed: auto || qp['fast_variant'] === 'yes' };
}
